module.exports = __webpack_public_path__ + "img/shape-1-gold@2x.6e8d54b9.png";